export const downloadFile = (fileURL: any, fileName: string) => {
    let link = document.createElement('a');
    link.href = fileURL;
    link.download = `${fileName}`;
    link.click();
}